import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PricingSelectedProductsComponent } from '@app/pricing/components/pricing-selected-products/pricing-selected-products.component';
import { ProductBasicDataComponent } from '@products/components/product-basic-data/product-basic-data.component';
import { ProductCollectionsComponent } from '@products/components/product-collections/product-collections.component';
import { ProductImagesComponent } from '@products/components/product-images/product-images.component';
import { ProductEditComponent } from '@products/containers/product-edit/product-edit.component';
import { CanDeactivateGuard } from '@shared/guards/can-deactivate.guard';

import { VipDiscountsContainerComponent } from './containers/vip-discounts-container/vip-discounts-container.component';
import { VipDiscountsWithSearchComponent } from './containers/vip-discounts-with-search/vip-discounts-with-search.component';
import { VipDiscountsGivenComponent } from './pages/vip-discounts-given/vip-discounts-given.component';
import { VipDiscountsProductsAndPartnersComponent } from './pages/vip-discounts-products-and-partners/vip-discounts-products-and-partners.component';
import { VipDiscountsSettingsComponent } from './pages/vip-discounts-settings/vip-discounts-settings.component';

const routes: Routes = [
  {
    path: '',
    data: { searchLayout: true },
    component: VipDiscountsWithSearchComponent,
    children: [
      {
        path: '',
        component: VipDiscountsContainerComponent,
        children: [
          {
            path: 'products-and-partners',
            component: VipDiscountsProductsAndPartnersComponent,
          },
          {
            path: 'given',
            component: VipDiscountsGivenComponent,
          },
        ],
      },
      {
        path: 'product-view',
        component: ProductEditComponent,
        data: {
          readOnly: true,
          navigateFrom: 'VIP-DISCOUNTS',
        },
        children: [
          {
            path: '',
            component: ProductBasicDataComponent,
          },
          {
            path: 'images',
            component: ProductImagesComponent,
          },
          {
            path: 'collections',
            component: ProductCollectionsComponent,
          },
        ],
      },
    ],
  },

  {
    path: 'selected-products',
    component: PricingSelectedProductsComponent,
    canDeactivate: [CanDeactivateGuard],
  },

  {
    path: 'settings',
    component: VipDiscountsSettingsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VipDiscountsSellingRoutingModule {}
